import { render, staticRenderFns } from "./SubscriptionTab.vue?vue&type=template&id=60711a15&v-slot%3Aextension=true"
import script from "./SubscriptionTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports